import { PaginationButton } from "./PaginationButton";
type PaginationProps = {
  currentPage: number;
  totalData: number;
  rowsPerPage: number;
  totalPages: number;
  isTableDataLoading?: boolean;
  onPageChange: (page: number,type?:string) => void;
  activePages: number[];
};

export const PaginationLayout = ({
  isTableDataLoading,
  totalData,
  currentPage,
  rowsPerPage,
  totalPages,
  onPageChange,
  activePages,
}: PaginationProps) => {
  return (
    <div>
      <PaginationButton
        onClick={() => onPageChange(1, "first")}
        disabled={currentPage === 1 || isTableDataLoading}
      >
        <img
          src={
            currentPage === 1
              ? require("../../assets/images/left-double-arrow-icon-disabled.png")
              : require("../../assets/images/left-double-arrow-icon.png")
          }
          alt="left-icon"
        />
      </PaginationButton>
      <PaginationButton
        onClick={() => onPageChange(currentPage - 1, "prev")}
        disabled={currentPage === 1 || isTableDataLoading}
      >
        <img
          src={
            currentPage === 1
              ? require("../../assets/images/left-arrow-icon-disabled.png")
              : require("../../assets/images/left-arrow-icon.png")
          }
          alt="left-icon"
        />
      </PaginationButton>
      {!activePages.includes(1) && (
        <PaginationButton
          onClick={() => onPageChange(activePages[0] - 1, "trunc-prev")}
          disabled={isTableDataLoading}
        >
          <span>...</span>
        </PaginationButton>
      )}
      {activePages.map((pageNo: number, idx: number) => (
        <PaginationButton
          disabled={isTableDataLoading}
          key={idx}
          label={pageNo}
          isActive={currentPage === pageNo}
          onClick={() => onPageChange(pageNo)}
        />
      ))}
      {!activePages.includes(totalPages) && (
        <PaginationButton
          onClick={() => onPageChange(activePages[4] + 1, "trunc-next")}
          disabled={isTableDataLoading}
        >
          <span>...</span>
        </PaginationButton>
      )}
      <PaginationButton
        onClick={() => onPageChange(currentPage + 1, "next")}
        disabled={currentPage === totalPages || isTableDataLoading}
      >
        <img
          src={
            currentPage === totalPages
              ? require("../../assets/images/right-arrow-icon-disabled.png")
              : require("../../assets/images/right-arrow-icon.png")
          }
          alt="right-icon"
        />
      </PaginationButton>
      <PaginationButton
        onClick={() => onPageChange(totalPages, "last")}
        disabled={currentPage === totalPages || isTableDataLoading}
      >
        <img
          src={
            currentPage === totalPages
              ? require("../../assets/images/right-double-arrow-icon-disabled.png")
              : require("../../assets/images/right-double-arrow-icon.png")
          }
          alt="right-icon"
        />
      </PaginationButton>
    </div>
  );
};
